/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from "react";

// Curated still-image demos (Giphy GIF embeds via direct URL, safe for iframes)
const exerciseDemos = {
  "Easy Water Walk":           { gif: "https://media.giphy.com/media/3oKIPnbKgN3bXeVpvy/giphy.gif", yt: "pool water walking exercise" },
  "Hip Circles":               { gif: "https://media.giphy.com/media/l0HlBO7eyXzSZkJri/giphy.gif", yt: "standing hip circles mobility" },
  "Leg Swings":                { gif: "https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif", yt: "leg swings dynamic stretch" },
  "High Knee Sprint":          { gif: "https://media.giphy.com/media/3oKIPrc2ngFZ6BTyww/giphy.gif", yt: "aqua high knees pool sprint" },
  "Squat Jumps":               { gif: "https://media.giphy.com/media/l0MYt5jPR6QX5pnqM/giphy.gif", yt: "pool squat jumps water resistance" },
  "Side Shuffle":              { gif: "https://media.giphy.com/media/3o7btNhMBytxAM6YBa/giphy.gif", yt: "pool side shuffle lateral water" },
  "Tuck Jumps":                { gif: "https://media.giphy.com/media/l46Cy1rHbQ92uuLXa/giphy.gif", yt: "tuck jumps pool aqua" },
  "Flutter Kick Hold":         { gif: "https://media.giphy.com/media/3oKIPxkBPMHireiePe/giphy.gif", yt: "flutter kicks pool wall hold" },
  "Pigeon Stretch (Pool Edge)":{ gif: "https://media.giphy.com/media/3oKIPu1AxMWB2xlwl2/giphy.gif", yt: "pigeon pose pool edge stretch" },
  "Chest Opener":              { gif: "https://media.giphy.com/media/l0HlHFRbmaZtBRhXG/giphy.gif", yt: "chest opener stretch water pool" },
  "Hamstring Walk":            { gif: "https://media.giphy.com/media/3oKIPqA9iMFMiGNKgU/giphy.gif", yt: "hamstring walk kick pool aqua" },
  "Jogging in Place":          { gif: "https://media.giphy.com/media/3oKIPnAiaMCws8nOsE/giphy.gif", yt: "aqua jogging in place pool" },
  "Arm Circles":               { gif: "https://media.giphy.com/media/3oKIPjHCmuXqdBvHDW/giphy.gif", yt: "arm circles pool water exercise" },
  "Torso Twists":              { gif: "https://media.giphy.com/media/3oKIPf3C7HqqYBVcCk/giphy.gif", yt: "torso twists water pool aqua" },
  "Water Running Intervals":   { gif: "https://media.giphy.com/media/3oKIPwoeGErMmaI43S/giphy.gif", yt: "deep water running aqua jogging belt" },
  "Cross-Country Ski":         { gif: "https://media.giphy.com/media/3oKIPcSBUSSAR3bTBS/giphy.gif", yt: "pool cross country ski aqua exercise" },
  "Rocking Horse":             { gif: "https://media.giphy.com/media/3oKIPpFhwsMNiSmZyU/giphy.gif", yt: "aqua rocking horse pool exercise" },
  "Noodle Pedaling":           { gif: "https://media.giphy.com/media/3oKIPjI8PdEQFQRdSU/giphy.gif", yt: "pool noodle bicycle pedaling exercise" },
  "Vertical Scissors":         { gif: "https://media.giphy.com/media/3oKIPmM7lhzPFXSNpK/giphy.gif", yt: "vertical scissors pool aqua abs" },
  "Noodle Plank":              { gif: "https://media.giphy.com/media/3oKIPjUc4jwsNdJEQ8/giphy.gif", yt: "pool noodle plank core exercise" },
  "Oblique Knee Drives":       { gif: "https://media.giphy.com/media/3oKIPjz3H0jUChRBSU/giphy.gif", yt: "oblique knee drives aqua exercise" },
  "Easy Lap Walk":             { gif: "https://media.giphy.com/media/3oKIPnbKgN3bXeVpvy/giphy.gif", yt: "pool lap walking easy aqua" },
  "Water Tai Chi Reaches":     { gif: "https://media.giphy.com/media/3oKIPjHCmuXqdBvHDW/giphy.gif", yt: "water tai chi pool exercise" },
  "IT Band Crossover Stretch": { gif: "https://media.giphy.com/media/3oKIPu1AxMWB2xlwl2/giphy.gif", yt: "IT band stretch pool water" },
  "Hip Flexor Lunge Hold":     { gif: "https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif", yt: "hip flexor lunge pool aqua" },
  "Calf/Achilles Float Stretch":{ gif: "https://media.giphy.com/media/3oKIPqA9iMFMiGNKgU/giphy.gif", yt: "calf achilles stretch pool wall" },
  "Thoracic Rotation":         { gif: "https://media.giphy.com/media/3oKIPf3C7HqqYBVcCk/giphy.gif", yt: "thoracic rotation stretch pool" },
  "Wide-Stance Hip Opener":    { gif: "https://media.giphy.com/media/l0HlBO7eyXzSZkJri/giphy.gif", yt: "wide stance hip opener pool frog" },
  "Dead Man's Float":          { gif: "https://media.giphy.com/media/3oKIPwoeGErMmaI43S/giphy.gif", yt: "dead man float pool relaxation" },
  "Slow Lap Backstroke":       { gif: "https://media.giphy.com/media/3oKIPcSBUSSAR3bTBS/giphy.gif", yt: "easy backstroke lap pool" },
};

const workouts = {
  A: {
    label: "Day A — Power & Legs",
    focus: "Cycling strength, glutes, quads, hip flexors",
    emoji: "🚴",
    color: "#00c8ff",
    blocks: [
      {
        name: "Warm-Up", duration: 5,
        exercises: [
          { name: "Easy Water Walk", sets: 1, reps: "2 min", cues: "Chest-deep water, exaggerated arm swing, wake up the joints." },
          { name: "Hip Circles", sets: 1, reps: "10 each side", cues: "Hold pool wall, draw big circles with your knee. Loosen the hip capsule." },
          { name: "Leg Swings", sets: 1, reps: "15 each leg", cues: "Front-to-back then lateral. Feel the hip flexor stretch on the back swing." },
        ]
      },
      {
        name: "Main Set", duration: 25,
        exercises: [
          { name: "High Knee Sprint", sets: 3, reps: "30 sec on / 30 sec rest", cues: "Drive knees to waist height. Use water resistance. Go hard." },
          { name: "Squat Jumps", sets: 3, reps: "12 reps", cues: "Chest-deep water, squat then explode up. Land soft. Great for cycling power." },
          { name: "Side Shuffle", sets: 3, reps: "20m each direction", cues: "Lateral power through the water. Hip abductors — often weak in cyclists." },
          { name: "Tuck Jumps", sets: 2, reps: "10 reps", cues: "Pull knees to chest at the top. Forces core engagement." },
          { name: "Flutter Kick Hold", sets: 3, reps: "45 sec", cues: "Hold wall or noodle, face down. Fast small kicks. Hip flexor endurance = free watts." },
        ]
      },
      {
        name: "Mobility Cooldown", duration: 8,
        exercises: [
          { name: "Pigeon Stretch (Pool Edge)", sets: 1, reps: "60 sec each side", cues: "Lean forward against wall, cross one ankle over opposite knee. Glute stretch." },
          { name: "Chest Opener", sets: 1, reps: "45 sec", cues: "Arms wide, press back against water resistance. Opens thoracic — great for cycling posture." },
          { name: "Hamstring Walk", sets: 1, reps: "2 min easy", cues: "Slow walk, kick legs straight out front. Don't rush." },
        ]
      }
    ]
  },
  B: {
    label: "Day B — Cardio & Core",
    focus: "Fat burn, core stability, aerobic base",
    emoji: "🔥",
    color: "#ff6b35",
    blocks: [
      {
        name: "Warm-Up", duration: 5,
        exercises: [
          { name: "Jogging in Place", sets: 1, reps: "90 sec", cues: "Waist-deep water, easy effort. Get the heart rate climbing gradually." },
          { name: "Arm Circles", sets: 1, reps: "20 each direction", cues: "Submerge arms, push through the water. Shoulder mobility." },
          { name: "Torso Twists", sets: 1, reps: "20 reps", cues: "Feet planted, rotate upper body through water resistance. Spine wake-up." },
        ]
      },
      {
        name: "Cardio Intervals", duration: 20,
        exercises: [
          { name: "Water Running Intervals", sets: 4, reps: "1 min hard / 30 sec easy", cues: "Deep end with flotation belt if needed. Same feel as treadmill intervals, zero impact." },
          { name: "Cross-Country Ski", sets: 3, reps: "40 sec", cues: "Opposite arm/leg forward simultaneously. Full body, high HR." },
          { name: "Rocking Horse", sets: 3, reps: "30 sec each leg", cues: "Lunge one leg forward, hop and switch. Cardio + hip flexor work." },
          { name: "Noodle Pedaling", sets: 2, reps: "60 sec", cues: "Sit on pool noodle like a bike seat, pedal through water. Actual cycling motion." },
        ]
      },
      {
        name: "Core Finisher", duration: 10,
        exercises: [
          { name: "Vertical Scissors", sets: 3, reps: "30 sec", cues: "Tread water, spread legs wide then cross them. Lower abs fire hard." },
          { name: "Noodle Plank", sets: 3, reps: "30 sec hold", cues: "Hold noodle at arm's length, lean forward, hold horizontal. Deep core." },
          { name: "Oblique Knee Drives", sets: 2, reps: "15 each side", cues: "Stand in water, drive knee diagonally across body to opposite elbow." },
        ]
      }
    ]
  },
  C: {
    label: "Day C — Mobility & Recovery",
    focus: "Active recovery, flexibility, parasympathetic reset",
    emoji: "🌊",
    color: "#7c3aed",
    blocks: [
      {
        name: "Flowing Movement", duration: 10,
        exercises: [
          { name: "Easy Lap Walk", sets: 1, reps: "3-4 laps", cues: "Arms sweeping wide. Move through the water, don't fight it. Meditative pace." },
          { name: "Water Tai Chi Reaches", sets: 1, reps: "5 min", cues: "Slow, deliberate arm movements under water. Shoulder mobility, calm the nervous system." },
        ]
      },
      {
        name: "Targeted Stretch", duration: 20,
        exercises: [
          { name: "IT Band Crossover Stretch", sets: 1, reps: "90 sec each side", cues: "Stand chest-deep, cross one foot behind the other, lean away. Classic cyclist tightness." },
          { name: "Hip Flexor Lunge Hold", sets: 2, reps: "60 sec each", cues: "Deep lunge position in shallow end. Water supports you, let the hip open." },
          { name: "Calf/Achilles Float Stretch", sets: 1, reps: "60 sec each", cues: "Hold wall, extend one leg back with heel pressing down. Critical for cyclists." },
          { name: "Thoracic Rotation", sets: 1, reps: "10 each side", cues: "Arms crossed, rotate upper body only. Buoyancy decompresses your spine." },
          { name: "Wide-Stance Hip Opener", sets: 1, reps: "90 sec", cues: "Frog-like stance in chest-deep water. Squat slightly, let hips open outward. Adductor release." },
        ]
      },
      {
        name: "Breathwork Cooldown", duration: 5,
        exercises: [
          { name: "Dead Man's Float", sets: 1, reps: "5 breaths", cues: "Face-down, arms relaxed. Full exhale, let your back crest the surface. Pure relaxation." },
          { name: "Slow Lap Backstroke", sets: 1, reps: "2 laps", cues: "No technique required. Just float and move. Let the water hold you." },
        ]
      }
    ]
  }
};

const schedule = [
  { day: "Mon", workout: "A", label: "Power" },
  { day: "Tue", workout: null, label: "Rest/Ride" },
  { day: "Wed", workout: "B", label: "Cardio" },
  { day: "Thu", workout: null, label: "Rest/Ride" },
  { day: "Fri", workout: null, label: "Rest/Ride" },
  { day: "Sat", workout: "C", label: "Mobility" },
  { day: "Sun", workout: null, label: "Long Ride" },
];

function TimerRing({ seconds, total, color }) {
  const r = 48;
  const circ = 2 * Math.PI * r;
  const dash = circ * (seconds / total);
  return (
    <svg width="120" height="120" viewBox="0 0 120 120">
      <circle cx="60" cy="60" r={r} fill="none" stroke="#1a1a2e" strokeWidth="8"/>
      <circle cx="60" cy="60" r={r} fill="none" stroke={color} strokeWidth="8"
        strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
        transform="rotate(-90 60 60)" style={{ transition: "stroke-dasharray 0.5s ease" }}/>
      <text x="60" y="65" textAnchor="middle" fill="white" fontSize="22"
        fontFamily="'Courier New', monospace" fontWeight="bold">
        {String(Math.floor(seconds / 60)).padStart(2,"0")}:{String(seconds % 60).padStart(2,"0")}
      </text>
    </svg>
  );
}

// Demo modal — shows YouTube search link + a placeholder visual
function DemoModal({ exName, color, onClose }) {
  const ytUrl = `https://www.youtube.com/results?search_query=${encodeURIComponent("aqua pool " + exName + " exercise demo")}`;

  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 1000,
      background: "rgba(0,0,0,0.82)", backdropFilter: "blur(6px)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: 20
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: "linear-gradient(160deg, #0a1628, #060e1a)",
        border: `1px solid ${color}44`,
        borderRadius: 20, padding: 24, maxWidth: 400, width: "100%",
        boxShadow: `0 0 40px ${color}22`
      }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 18 }}>
          <div>
            <div style={{ fontSize: 11, letterSpacing: "0.2em", color: color, textTransform: "uppercase", marginBottom: 4 }}>
              Exercise Demo
            </div>
            <div style={{ fontSize: 18, color: "#d0e8f8", fontWeight: "bold" }}>{exName}</div>
          </div>
          <button onClick={onClose} style={{
            background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "50%", width: 32, height: 32, cursor: "pointer",
            color: "#7090a8", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center"
          }}>×</button>
        </div>

        {/* Visual placeholder with pool icon */}
        <div style={{
          borderRadius: 12, marginBottom: 18, overflow: "hidden",
          background: `linear-gradient(135deg, ${color}11, rgba(0,0,0,0.3))`,
          border: `1px solid ${color}22`,
          height: 160, display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", gap: 10
        }}>
          <div style={{ fontSize: 48 }}>🏊</div>
          <div style={{ fontSize: 12, color: "#4a7090", textAlign: "center", padding: "0 20px" }}>
            Watch a demo on YouTube for the best visual guide
          </div>
        </div>

        {/* YouTube CTA */}
        <a href={ytUrl} target="_blank" rel="noopener noreferrer" style={{
          display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
          padding: "14px 20px", borderRadius: 12, textDecoration: "none",
          background: "linear-gradient(135deg, #ff0000cc, #cc0000cc)",
          border: "1px solid #ff000044",
          color: "white", fontSize: 14, fontWeight: "bold",
          marginBottom: 10, cursor: "pointer"
        }}>
          <span style={{ fontSize: 20 }}>▶</span>
          Watch on YouTube
        </a>

        {/* Secondary: Google search */}
        <a href={`https://www.google.com/search?q=how+to+do+${encodeURIComponent(exName)}+in+pool&tbm=vid`}
          target="_blank" rel="noopener noreferrer" style={{
          display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
          padding: "10px 20px", borderRadius: 12, textDecoration: "none",
          background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)",
          color: "#7090a8", fontSize: 12, cursor: "pointer"
        }}>
          🔍 Search Google Videos
        </a>

        <div style={{ textAlign: "center", marginTop: 14, fontSize: 10, color: "#2a4050" }}>
          Tap outside to close
        </div>
      </div>
    </div>
  );
}

function ExerciseCard({ ex, color }) {
  const [showDemo, setShowDemo] = useState(false);
  return (
    <>
      <div style={{
        borderRadius: 12, padding: "14px 16px", marginBottom: 8,
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.07)"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div style={{ fontSize: 14, color: "#c8e0f0", fontWeight: "bold", flex: 1 }}>{ex.name}</div>
          <div style={{
            fontSize: 10, padding: "3px 10px", borderRadius: 20,
            background: color + "22", color: color,
            border: `1px solid ${color}44`, whiteSpace: "nowrap", marginLeft: 10
          }}>
            {ex.sets > 1 ? `${ex.sets}×` : ""} {ex.reps}
          </div>
        </div>
        <div style={{ fontSize: 12, color: "#4a7090", lineHeight: 1.5, fontStyle: "italic", marginBottom: 10 }}>
          {ex.cues}
        </div>
        {/* Demo button */}
        <button
          onClick={() => setShowDemo(true)}
          style={{
            display: "flex", alignItems: "center", gap: 6,
            padding: "5px 12px", borderRadius: 20, cursor: "pointer",
            background: "rgba(255,255,255,0.04)",
            border: `1px solid ${color}55`,
            color: color, fontSize: 11, fontFamily: "Georgia, serif"
          }}
        >
          <span style={{ fontSize: 13 }}>▶</span> See demo
        </button>
      </div>
      {showDemo && <DemoModal exName={ex.name} color={color} onClose={() => setShowDemo(false)} />}
    </>
  );
}

export default function PoolApp() {
  const [view, setView] = useState("home");
  const [selectedDay, setSelectedDay] = useState(null);
  const [timerSec, setTimerSec] = useState(0);
  const [timerTotal, setTimerTotal] = useState(0);
  const [timerRunning, setTimerRunning] = useState(false);
  const intervalRef = useRef(null);

  const workout = selectedDay ? workouts[selectedDay] : null;

  useEffect(() => {
    if (timerRunning && timerSec > 0) {
      intervalRef.current = setInterval(() => setTimerSec(s => s - 1), 1000);
    } else if (timerSec === 0 && timerRunning) {
      setTimerRunning(false);
    }
    return () => clearInterval(intervalRef.current);
  }, [timerRunning, timerSec]);

  function startTimer(mins) {
    clearInterval(intervalRef.current);
    const s = Math.round(mins * 60);
    setTimerSec(s); setTimerTotal(s); setTimerRunning(true);
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(160deg, #050b1f 0%, #0a1628 50%, #060e1a 100%)",
      fontFamily: "'Georgia', serif", color: "#e0e8f0", position: "relative", overflow: "hidden"
    }}>
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 0,
        background: "radial-gradient(ellipse at 20% 80%, rgba(0,120,200,0.08) 0%, transparent 50%), radial-gradient(ellipse at 80% 20%, rgba(0,80,180,0.06) 0%, transparent 50%)"
      }}/>

      <div style={{ position: "relative", zIndex: 1, maxWidth: 520, margin: "0 auto", padding: "24px 16px 40px" }}>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 11, letterSpacing: "0.25em", color: "#4a8fb8", textTransform: "uppercase", marginBottom: 8 }}>
            AQUA CROSS-TRAINING
          </div>
          <h1 style={{
            fontSize: 28, fontWeight: "normal", margin: "0 0 4px",
            background: "linear-gradient(135deg, #a8d8f0, #ffffff, #7ec8e3)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", letterSpacing: "-0.5px"
          }}>Pool Workout</h1>
          <div style={{ fontSize: 13, color: "#4a7090", fontStyle: "italic" }}>Dolomites prep · Summer 2026</div>
        </div>

        {view === "home" && (
          <>
            {/* Weekly grid */}
            <div style={{ marginBottom: 28 }}>
              <div style={{ fontSize: 10, letterSpacing: "0.2em", color: "#4a6a88", marginBottom: 12, textTransform: "uppercase" }}>Weekly Template</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4 }}>
                {schedule.map(({ day, workout: w, label }) => (
                  <div key={day} onClick={() => { if (w) { setSelectedDay(w); setView("workout"); } }}
                    style={{
                      borderRadius: 8, padding: "8px 4px", textAlign: "center",
                      background: w ? `${workouts[w].color}22` : "rgba(255,255,255,0.03)",
                      border: `1px solid ${w ? workouts[w].color + "44" : "rgba(255,255,255,0.06)"}`,
                      cursor: w ? "pointer" : "default",
                    }}>
                    <div style={{ fontSize: 9, color: "#4a6a88", marginBottom: 4 }}>{day}</div>
                    <div style={{ fontSize: w ? 16 : 12, marginBottom: 2 }}>{w ? workouts[w].emoji : "—"}</div>
                    <div style={{ fontSize: 8, color: w ? workouts[w].color : "#334", lineHeight: 1.2 }}>{label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Workout cards */}
            <div style={{ fontSize: 10, letterSpacing: "0.2em", color: "#4a6a88", marginBottom: 12, textTransform: "uppercase" }}>Choose A Workout</div>
            {Object.entries(workouts).map(([key, w]) => (
              <div key={key} onClick={() => { setSelectedDay(key); setView("workout"); }}
                style={{
                  borderRadius: 16, padding: "20px 22px", marginBottom: 14,
                  background: "linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01))",
                  border: `1px solid ${w.color}33`, cursor: "pointer", transition: "border-color 0.2s",
                  position: "relative", overflow: "hidden"
                }}
                onMouseEnter={e => e.currentTarget.style.borderColor = w.color + "88"}
                onMouseLeave={e => e.currentTarget.style.borderColor = w.color + "33"}
              >
                <div style={{ position: "absolute", right: -10, top: -10, fontSize: 60, opacity: 0.06 }}>{w.emoji}</div>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
                  <div style={{
                    width: 32, height: 32, borderRadius: "50%",
                    background: w.color + "22", border: `1px solid ${w.color}66`,
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16
                  }}>{w.emoji}</div>
                  <div>
                    <div style={{ fontSize: 15, color: "#d0e8f8", fontWeight: "bold", letterSpacing: "-0.3px" }}>{w.label}</div>
                    <div style={{ fontSize: 11, color: w.color, opacity: 0.85 }}>{w.focus}</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
                  {w.blocks.map(b => (
                    <div key={b.name} style={{
                      fontSize: 9, padding: "3px 8px", borderRadius: 20,
                      background: "rgba(255,255,255,0.05)", color: "#7a9ab8",
                      border: "1px solid rgba(255,255,255,0.08)"
                    }}>{b.name} · {b.duration}m</div>
                  ))}
                </div>
              </div>
            ))}

            {/* Tips */}
            <div style={{
              marginTop: 8, borderRadius: 12, padding: "16px 18px",
              background: "rgba(0,100,200,0.08)", border: "1px solid rgba(0,150,255,0.15)"
            }}>
              <div style={{ fontSize: 10, letterSpacing: "0.15em", color: "#4a8fb8", marginBottom: 10, textTransform: "uppercase" }}>🚴 Cycling Sync Tips</div>
              {[
                ["Pool Day A", "Ideally NOT the day before a long ride. Power work."],
                ["Pool Day B", "Fine before easy spin days. Good aerobic complement."],
                ["Pool Day C", "Perfect the day after your long ride. Active recovery."],
                ["Ketones", "KE4 pre-pool on Day A like pre-ride. Skip on Day C."],
              ].map(([label, tip]) => (
                <div key={label} style={{ display: "flex", gap: 10, marginBottom: 8, fontSize: 12 }}>
                  <span style={{ color: "#00c8ff", minWidth: 80 }}>{label}</span>
                  <span style={{ color: "#7090a8" }}>{tip}</span>
                </div>
              ))}
            </div>
          </>
        )}

        {view === "workout" && workout && (
          <>
            <button onClick={() => setView("home")} style={{
              background: "none", border: "none", color: "#4a8fb8", cursor: "pointer",
              fontSize: 13, marginBottom: 20, padding: 0, display: "flex", alignItems: "center", gap: 6
            }}>← Back</button>

            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 24, marginBottom: 4 }}>
                <span style={{ marginRight: 10 }}>{workout.emoji}</span>
                <span style={{ color: "#d0e8f8", letterSpacing: "-0.5px" }}>{workout.label}</span>
              </div>
              <div style={{ fontSize: 13, color: workout.color, fontStyle: "italic" }}>{workout.focus}</div>
            </div>

            {workout.blocks.map((block, bi) => (
              <div key={bi} style={{ marginBottom: 20 }}>
                <div style={{
                  fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase",
                  color: workout.color, marginBottom: 10, display: "flex", alignItems: "center", gap: 8
                }}>
                  <div style={{ flex: 1, height: 1, background: workout.color + "33" }}/>
                  {block.name} · {block.duration} min
                  <div style={{ flex: 1, height: 1, background: workout.color + "33" }}/>
                </div>
                {block.exercises.map((ex, ei) => (
                  <ExerciseCard key={ei} ex={ex} color={workout.color} />
                ))}
              </div>
            ))}

            {/* Timer */}
            <div style={{
              borderRadius: 16, padding: "20px",
              background: "rgba(0,100,200,0.08)",
              border: `1px solid ${workout.color}33`,
              textAlign: "center", marginTop: 16
            }}>
              <div style={{ fontSize: 10, letterSpacing: "0.2em", color: "#4a8fb8", marginBottom: 16, textTransform: "uppercase" }}>Interval Timer</div>
              <TimerRing seconds={timerSec} total={timerTotal || 1} color={workout.color} />
              <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 16, flexWrap: "wrap" }}>
                {[0.5, 1, 1.5, 2, 3].map(m => (
                  <button key={m} onClick={() => startTimer(m)} style={{
                    padding: "6px 14px", borderRadius: 20, cursor: "pointer",
                    background: "rgba(255,255,255,0.06)", border: `1px solid ${workout.color}44`,
                    color: "#a0c8e0", fontSize: 12
                  }}>{m < 1 ? "30s" : `${m}m`}</button>
                ))}
                <button onClick={() => setTimerRunning(r => !r)} style={{
                  padding: "6px 16px", borderRadius: 20, cursor: "pointer",
                  background: timerRunning ? workout.color + "33" : "rgba(255,255,255,0.05)",
                  border: `1px solid ${workout.color}`,
                  color: workout.color, fontSize: 12, fontWeight: "bold"
                }}>
                  {timerRunning ? "⏸ Pause" : "▶ Resume"}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

